import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "box has-background-grey-dark" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = ["data-tooltip"]
const _hoisted_4 = ["data-tooltip"]
const _hoisted_5 = ["data-tooltip"]
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { class: "input-checkbox-wrapper" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { class: "input-checkbox-wrapper" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { class: "button-group" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timestamp = _resolveComponent("Timestamp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title-wrap" }, [
      _createElementVNode("h1", { class: "title mb-1" }, "Alerts page")
    ], -1)),
    _createVNode(_component_Timestamp, { "timestamp-data": _ctx.timestampData }, null, 8, ["timestamp-data"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header" }, "Alerts", -1)),
      _createElementVNode("table", null, [
        _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Strategy"),
            _createElementVNode("th", null, "Change"),
            _createElementVNode("th", null, "Mid"),
            _createElementVNode("th", null, "5PM Close"),
            _createElementVNode("th", null, "Notification (<)"),
            _createElementVNode("th", null, "Notification (>)"),
            _createElementVNode("th", null, "Action")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGridData(_ctx.gridData), (entry) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: entry.Strategy,
              class: _normalizeClass(_ctx.getRowClass(entry))
            }, [
              (entry['Strategy'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: _normalizeClass({ strat_up: (entry['a_status'] == 'a_up'), strat_down: (entry['a_status'] == 'a_down')}),
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, _toDisplayString(entry['Strategy'].substring(entry['Strategy'].length, entry['Strategy'].indexOf('-') != -1 ? entry['Strategy'].indexOf('-') : 0).replace('-', '')), 11, _hoisted_3))
                : _createCommentVNode("", true),
              (entry['Change'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 1,
                    class: _normalizeClass({ inc_a : (entry['a_status'] == 'a_up') , dec_a: (entry['a_status'] == 'a_down') }),
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, _toDisplayString(entry['Change']), 11, _hoisted_4))
                : _createCommentVNode("", true),
              (entry['Mid'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 2,
                    "data-tooltip": entry['strat_legs'],
                    class: "mid"
                  }, _toDisplayString(entry['Mid']), 9, _hoisted_5))
                : _createCommentVNode("", true),
              (entry['3PM Close'])
                ? (_openBlock(), _createElementBlock("td", {
                    key: 3,
                    "data-tooltip": entry['strat_legs'].substring(0,20)
                  }, _toDisplayString(entry['3PM Close']), 9, _hoisted_6))
                : _createCommentVNode("", true),
              (entry['Strategy'])
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        step: "0.001",
                        "onUpdate:modelValue": ($event: any) => ((entry.belowThreshold) = $event)
                      }, null, 8, _hoisted_9), [
                        [
                          _vModelText,
                          entry.belowThreshold,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (entry['Strategy'])
                ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        step: "0.001",
                        "onUpdate:modelValue": ($event: any) => ((entry.aboveThreshold) = $event)
                      }, null, 8, _hoisted_12), [
                        [
                          _vModelText,
                          entry.aboveThreshold,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (entry['Strategy'])
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.clearValues(entry))
                      }, "Clear", 8, _hoisted_15),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.saveValues(entry))
                      }, "Save", 8, _hoisted_16)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadValues && _ctx.loadValues(...args)))
    }, "Load")
  ]))
}